export function buildPermissions(hasRole) {
	const safeHasRole = (role) => (typeof hasRole === "function" ? !!hasRole(role) : false);

	const isAdministrator = safeHasRole("ngom-administrator");
	const isPowerUser = safeHasRole("ngom-powerUser");
	const canViewOperationalDataView = isPowerUser || isAdministrator;
	const canViewBusinessDataView =
		canViewOperationalDataView ||
		safeHasRole("ngom-businessuser") ||
		safeHasRole("ngom-user");

	const defaultDataViewPath = canViewOperationalDataView
		? "/operational-dataview"
		: canViewBusinessDataView
			? "/business-dataview"
			: "/";

	return {
		canViewBusinessDataView,
		canViewOperationalDataView,
		defaultDataViewPath,
	};
}

